import { getRequest } from 'utils/http'

export const getAllResourcesApi = () => {
  return getRequest('/resources')
}
